// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

console.log("Loading Even Session Report Controller");

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["simulationCount", "skillCount", "fieldCount"];

  connect() {
    this.loadParticipantRatings();
  }

  loadParticipantRatings() {
    const participantLis = this.element.querySelectorAll(".participant-li");

    participantLis.forEach((li) => {
      const participantId = li.dataset.id;
      const eventId = li.dataset.event;

      // Load simulation ratings
      this.fetchRatings(
        participantId,
        eventId,
        "simulation",
        li.querySelector(".sim-ratings-count")
      );

      // Load skill ratings
      this.fetchRatings(
        participantId,
        eventId,
        "skill",
        li.querySelector(".skill-ratings-count")
      );

      // Load field ratings
      this.fetchRatings(
        participantId,
        eventId,
        "field",
        li.querySelector(".field-ratings-count")
      );
    });
  }

  async fetchRatings(participantId, eventId, type, element) {
    try {
      const response = await fetch(
        `/api/participants/${participantId}/event/${eventId}/${type}_ratings`
      );
      const data = await response.json();
      console.log("DATA", data);
      if (type === "simulation") {
        element.textContent = `Simulations (lead): ${data.count}`;
      } else if (type === "skill") {
        element.textContent = `Skill Ratings: ${data.count}`;
      } else if (type === "field") {
        element.textContent = `Field Ratings: ${data.count}`;
      }
    } catch (error) {
      console.error(`Error loading ${type} ratings:`, error);
      element.textContent = `Error loading ${type} ratings`;
    }
  }
}
